/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-17 17:36:16
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 18:07:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/index.ts
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-25 11:35:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/index.ts
 */

/**
 *  Sales Channel Content Reducer Set
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import {
  // createSlice,
  // createSelector,
  // createAsyncThunk,
  combineReducers,
} from '@reduxjs/toolkit';

import homepage from '../SalesChannelEditorHomepage/slice';
import productSearch from '../SalesChannelEditorProductSearch/slice';
import notFoundPage from '../SalesChannelEditor404Page/slice';
// import shoppingCartPage from '../SalesChannelEditorShoppingCartPage/redux';
import promotion from '../SalesChannelEditorPromotion/redux';
import tabBar from '../SalesChannelEditorTabbar/slice';
// import shoppingCartPage from '../SalesChannelEditorShoppingCartPage/slice';
import shoppingCartPage from '../SalesChannelEditorShoppingCartPage/slice';
import contentPage from '../SalesChannelContentPage/EditorPage/slice';
import profilePage from '../SalesChannelEditorProfilePage/slice';
import appearance from '../SalesChannelEditorAppearance/slice';
import allProductsPage from '../SalesChannelEditorAllProductPage/slice';
import navigation from '../SalesChannelEditorNavigation/slice';
import header from '../SalesChannelEditorHeader/slice';
import footer from '../SalesChannelFooter/slice';
import megaMenu from '../SalesChannelMegaMenu/slice';
import animation from '../SalesChannelEditorAnimation/slice';
import text from '../SalesChannelEditorText/slice';
import button from '../SalesChannelEditorButton/slice';
import maintenance from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/slice';

const salesChannelContentReducer = combineReducers({
  homepage,
  productSearch,
  notFoundPage,
  //shoppingCartPage,
  promotion,
  tabBar,
  shoppingCartPage,

  profilePage,
  contentPage,
  allProductsPage,
  appearance,
  navigation,
  header,
  footer,
  megaMenu,
  animation,
  text,
  button,
  maintenance,
});
export default salesChannelContentReducer;
export { EnumReducers } from './reduxCommonFunctions';
